<template>
  <div v-if="selectedMenu" class="text-base p-8 overflow-hidden">
    <div class="flex flex-1">
      <!--wrapped case-->
      <MenuVariantWrapped v-if="menuType === 'menu-wrapped'" :selected-menu="selectedMenu" />
      <!--widget case-->
      <MenuVariantWidget v-else-if="menuType === 'menu-widget'" :selected-menu="selectedMenu" />
      <!--default case-->
      <MenuVariantColumn v-else :selected-menu="selectedMenu" />
    </div>
    <div v-if="targetingValue" class="flex space-x-8" :class="menuType !== 'menu-wrapped' ? 'mt-5' : 'mt-4'">
      <AdRenderer type="GPT" unit-name="megamenuAd" :targeting="{ mega_menu: [`${targetingValue}_sol`] }" />
      <AdRenderer type="GPT" unit-name="megamenuAd" :targeting="{ mega_menu: [`${targetingValue}_orta`] }" />
      <AdRenderer type="GPT" unit-name="megamenuAd" :targeting="{ mega_menu: [`${targetingValue}_sag`] }" />
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from '@nuxtjs/composition-api';
import MenuVariantWrapped from '~/modules/common/components/app/header/CategoryMenu/MenuVariantWrapped';
import MenuVariantColumn from '~/modules/common/components/app/header/CategoryMenu/MenuVariantColumn';
import MenuVariantWidget from '~/modules/common/components/app/header/CategoryMenu/MenuVariantWidget';
import AdRenderer from '~/modules/ads/components/AdRenderer';
export default defineComponent({
  components: { MenuVariantWidget, MenuVariantColumn, MenuVariantWrapped, AdRenderer },
  props: {
    selectedMenu: {
      type: Object,
    },
  },
  setup(props) {
    const menuTypes = {
      Gündem: 'default',
      Test: 'menu-widget',
      Video: 'menu-widget',
      Yemek: 'menu-wrapped',
      'Ev, Yaşam & Gezi': 'menu-wrapped',
      Vitrin: 'menu-widget',
      Para: 'menu-wrapped',
      'TV & Sinema': 'default',
      Eğlence: 'default',
      Bilgisel: 'menu-wrapped',
    };
    const targetingKeys = {
      Gündem: 'gundem',
      Yemek: 'yemek',
      'Ev, Yaşam & Gezi': 'ev&yasam&gezi',
      Vitrin: 'vitrin',
      Para: 'para',
      'TV & Sinema': 'tv&sinema',
      Eğlence: 'eglence',
      Bilgisel: 'bilgisel',
    };
    const menuType = computed(() => menuTypes[props.selectedMenu?.shortName]);
    const targetingValue = computed(() => targetingKeys?.[props.selectedMenu?.shortName]);

    return { menuType, targetingValue };
  },
});
</script>

<style></style>
